// src/extenders/featured-info.js
var FeaturedInfoComponent = class extends HTMLElement {
  constructor() {
    super();
    const imageHolderElement = this.querySelector(".image-holder");
    const textHolderElement = this.querySelector(".text-holder");
    const textHolderInnerElement = textHolderElement ? textHolderElement.querySelector(".text-holder__inner") : null;
    const maxBreakpointMobile = "768px";
    const setImageSize = () => {
      if (imageHolderElement && textHolderInnerElement) {
        const heightTextHolderElement = textHolderInnerElement.clientHeight;
        if (matchMedia(`screen and (min-width: ${maxBreakpointMobile})`).matches) {
          imageHolderElement.style.height = `${heightTextHolderElement}px`;
        }
      }
    };
    setImageSize();
    window.addEventListener("resize", setImageSize);
  }
};
if (customElements.get("featured-info-component") === void 0) {
  customElements.define("featured-info-component", FeaturedInfoComponent);
}
